import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, formatRupiah } from "../lib/api";
import { MapPin, Calendar } from "lucide-react";

export default function Events() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/events").then(r => setItems(r.data)); }, []);
  return (
    <div data-testid="events-page">
      <section className="lumina-bg-soft py-20">
        <div className="lumina-container">
          <div className="lumina-label mb-3">Event & Acara</div>
          <h1 className="font-serif text-5xl md:text-6xl tracking-tighter text-[#1A1728] mb-6 max-w-3xl">Bergabunglah dengan komunitas yang merawat dirinya.</h1>
        </div>
      </section>
      <section className="lumina-container py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map(e => (
            <Link to={`/events/${e.slug}`} key={e.id} className="lumina-card overflow-hidden group" data-testid={`event-card-${e.slug}`}>
              <div className="aspect-[16/10] overflow-hidden">
                <img src={e.image} alt={e.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
              </div>
              <div className="p-6">
                <h3 className="font-serif text-2xl text-[#1A1728] mb-3 leading-tight">{e.title}</h3>
                <div className="text-xs text-[#5C5870] space-y-1 mb-4">
                  <div className="flex items-center gap-1.5"><Calendar className="w-3.5 h-3.5" /> {new Date(e.date).toLocaleDateString("id-ID", { day: "numeric", month: "long", year: "numeric" })}</div>
                  <div className="flex items-center gap-1.5"><MapPin className="w-3.5 h-3.5" /> {e.location}</div>
                </div>
                <p className="text-sm text-[#5C5870] line-clamp-2 mb-4">{e.description}</p>
                <div className="text-[#6B4BA3] font-semibold">{e.price === 0 ? "GRATIS" : formatRupiah(e.price)}</div>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
